import { form } from '../formState'
import * as Texts from '../../../intl'

export function Name({ simulationNames }: { simulationNames: string[] }) {
  form.useAddFieldValidation<'name'>('name', (field, _formApi) => {
    const value = (field.value || '').trim()

    if (!value) {
      return Texts.getSimulationValidationEmptyName()
    }

    if (simulationNames?.includes?.(value)) {
      return Texts.getSimulationValidationUniqueName()
    }
  })

  return (
    <form.TextField
      label={`${Texts.getSimulationNameFieldText()} *`}
      validateOn="change"
      name="name"
      testId="simulation-name"
    />
  )
}
